module.exports = __webpack_public_path__ + "img/cattunnel02.40fb608f.jpg";